module.exports = __webpack_public_path__ + "img/trzmiel.b13273dc.svg";